import React from 'react';
import TopHeader from './TopHeader';
import Breadcrumbs from './Breadcrumbs';
import HeaderNavigation from './navigations/HeaderNavigation';
import Logo from '../shared/Logo';
import LanguageSelector from '../shared/LanguageSelector';
export default function Header(_ref) {
  var appProps = _ref.appProps;
  var HeaderIcons = appProps.HeaderIcons,
    BelowHeaderPlacement = appProps.BelowHeaderPlacement;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "above_everything"
  }), /*#__PURE__*/React.createElement(TopHeader, {
    appProps: appProps
  }), /*#__PURE__*/React.createElement("header", {
    className: "header_wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header_row main-container header_v1"
  }, appProps.preferences.logo ? /*#__PURE__*/React.createElement(Logo, {
    appProps: appProps,
    target: '_self',
    classNames: 'header-v1-logo',
    logo: appProps.preferences.logo
  }) : /*#__PURE__*/React.createElement("div", {
    className: "site-name-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: appProps.rootPath,
    rel: "nofollow noindex"
  }, appProps.preferences.site_name ? appProps.preferences.site_name : '')), appProps.currentDevice === 'desktop' && /*#__PURE__*/React.createElement(HeaderNavigation, {
    appProps: appProps,
    navigation: appProps.navigation.header_menu
  }), /*#__PURE__*/React.createElement("div", {
    className: "header-icons",
    id: "header-icons-ajax-container"
  }, /*#__PURE__*/React.createElement(HeaderIcons, {
    appProps: appProps
  })))), BelowHeaderPlacement && /*#__PURE__*/React.createElement(BelowHeaderPlacement, {
    appProps: appProps
  }), /*#__PURE__*/React.createElement(Breadcrumbs, {
    breadcrumbs: appProps.breadcrumbs
  }), /*#__PURE__*/React.createElement("div", {
    id: "below_header"
  }));
}